import { homePageAlertFunction } from '@/modules/Dashboard/queries/homePageAlert/homePageAlertQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const homePageAlertQueryOptions = () =>
  // params: HomePageAlertQueryParamsType,
  {
    return queryOptions({
      queryKey: ['HomePageAlert'],
      queryFn: () => homePageAlertFunction(),
      enabled: true,
    });
  };
